/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Link1Inputs */

const en_coinvestments_outreach_link1 = /** @type {(inputs: Coinvestments_Outreach_Link1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Coinvestments_Outreach_Link1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_link1 = /** @type {((inputs?: Coinvestments_Outreach_Link1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Link1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_link1(inputs)
});
export { coinvestments_outreach_link1 as "coInvestments_outreach_link" }